import React from "react"
import { Helmet } from "react-helmet"

export const NoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
)
